import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgHome = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 20v-6H4c-1.782 0-2.674-2.154-1.414-3.414l8-8a2 2 0 0 1 2.828 0l8 8C22.674 11.846 21.782 14 20 14h-1v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Zm6 0h2v-4h-2v4Zm4 0v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H7v-8H4l8-8 8 8h-3v8h-2Z", fill: color }));
};
export default factorySvgIcon(SvgHome);
//# sourceMappingURL=SvgHome.js.map